import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { LocaleContext } from 'app/containers/LocaleProvider';
import PromocodeForm from 'app/components/Form/PromocodeForm';
import SnackbarBasket from 'app/components/SnackbarBasket';
import TextLine from 'app/components/ui/TextLine';

import { BillingContext } from '../../BillingProvider';
import { BasketContext } from '../../BasketProvider';
import { ConfigContext } from '../../ConfigProvider';

import { locales } from '../promo-checkout.locales';

import '../checkout-ny.scss';


function SuccessText({
    totals,
    l,
    useAdditionalDiscountText = '',
}) {
    if (totals.promocode_amount === 0) {
        return (
            <TextLine>
                {l.promocodeDiscountEmpty}
            </TextLine>
        );
    }

    return (
        <>
            <TextLine>
                {useAdditionalDiscountText
                    ? l.promocodeDiscountAdditional
                    : l.promocodeDiscount
                }
            </TextLine>
            {' '}
            {totals.promocode_amount}
            &nbsp;₽
        </>
    );
}

SuccessText.propTypes = {
    totals: PropTypes.shape({
        promocode_amount: PropTypes.number.isRequired,
    }).isRequired,
    l: PropTypes.shape({
        promocodeDiscountEmpty: PropTypes.string.isRequired,
        promocodeDiscountAdditional: PropTypes.string.isRequired,
        promocodeDiscount: PropTypes.string.isRequired,
    }).isRequired,
    useAdditionalDiscountText: PropTypes.bool,
};


export function CheckoutPromocode(props) {
    const {
        promocodeValue,
        isPromocodeLoading,
        handleChangePromocode,
        handleSubmitPromocode,
    } = props;

    const { billingState: { promocode } } = useContext(BillingContext);

    const {
        basket,
        promocodeConditions,
        isBasketRefetching,
    } = useContext(BasketContext);

    const {
        pageId,
        useAdditionalDiscountText,
    } = useContext(ConfigContext);

    const { locale } = useContext(LocaleContext);
    const l = locales[locale];

    // TODO: перенести в конфиг
    // TODO: не использовать промокод из сессии, если он выключен в конфиге
    if (pageId === 'gift') {
        return null;
    }

    return (
        <>
            <div styleName="checkout__input-wrap">
                <PromocodeForm
                    fillWidth
                    promocode={promocodeValue}
                    onChange={handleChangePromocode}
                    onSubmit={handleSubmitPromocode}
                    isLoading={isPromocodeLoading}
                    locale={locale}
                    placeholder={l.promocodeTitle}
                    applyText={l.apply}
                />
            </div>
            {promocode && promocode.length && (
                <div styleName="checkout__input-wrap">
                    <SnackbarBasket
                        isLoading={isBasketRefetching}
                        isPromocodeApplied={basket.totals.promocode_applied}
                        promocodeConditions={promocodeConditions}
                        pageId={pageId}
                        successText={(
                            <SuccessText
                                totals={basket.totals}
                                useAdditionalDiscountText={useAdditionalDiscountText}
                                l={l}
                            />
                        )}
                        difference={promocodeConditions.differenceBetweenPromocodeAndOrder}
                    />
                </div>
            )}
        </>
    );
}

CheckoutPromocode.propTypes = {
    promocodeValue: PropTypes.string.isRequired,
    isPromocodeLoading: PropTypes.bool.isRequired,
    handleChangePromocode: PropTypes.func.isRequired,
    handleSubmitPromocode: PropTypes.func.isRequired,
};
